export default "__VITE_ASSET__2JEb5wRM__"